/* eslint-disable react/no-danger */
/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Types
import { CTA } from '../../@types/cta';

// Components
import Text, { TEXT_TYPES } from '../text';
import CTAButton from '../ctaButton';

// Styles
import { baseStyle } from './style';

export interface heroV3WithTextProps {
  className?: string;
  title?: string;
  image: ImageType;
  content: string;
  cta?: CTA;
  sameSizeCol?: boolean;
}

const heroV3WithText: FunctionComponent<heroV3WithTextProps> = React.memo(
  ({
    title,
    image,
    content,
    cta,
    className,
    sameSizeCol,
  }: heroV3WithTextProps) => (
    <Box
      className={classNames('HeroV3WithText', className)}
      sx={baseStyle.mainContainer}
    >
      {title && (
        <Text type={TEXT_TYPES.H1_BOLD} sx={baseStyle.title}>
          {title}
        </Text>
      )}
      <Flex sx={baseStyle.mainRowContainer}>
        <Flex
          sx={{
            ...baseStyle.mainRowContainerLeft,
            ...(sameSizeCol ? baseStyle.sameSizeColumn : {}),
          }}
        >
          <FluidImage {...image} sx={baseStyle.image} />
        </Flex>
        <Box
          sx={{
            ...baseStyle.mainRowContainerRight,
            ...(sameSizeCol ? baseStyle.sameSizeColumn : {}),
          }}
        >
          <Text type={TEXT_TYPES.BODY_INTRO} sx={baseStyle.contentBody}>
            <span dangerouslySetInnerHTML={{ __html: content }} />
          </Text>
          <CTAButton type="link" cta={cta} sx={baseStyle.cta}>
            {cta?.label}
          </CTAButton>
        </Box>
      </Flex>
    </Box>
  ),
);

export default heroV3WithText;
